/*
 * Public API Surface of ng-navigator-share
 */

export * from './lib/ng-navigator-share/ng-navigator-share.service';
